<template>
  <div class="icy-road">
    <div class="hasData-wrap" v-show="times.length > 0">

      <div class="time-box">
        <div class="publish-time" v-show="pTime">
          <!--          <i class="el-icon-time"></i>-->
          <!--          数据时间：{{ pTime }}-->
          <div>{{ pTime }}更新</div>
        </div>
      </div>
      <div class="tab-box">
        <div :class="{ 'tab-item': true, active: currentIndex === index }" v-for="(name, index) in tabData" :key="index"
          @click="tabItemClick(index)">
          {{ name }}
        </div>
      </div>
      <div class="cont-box" v-show="currentIndex === 0">
        {{ ypcont ? ypcont : '无研判数据~' }}
      </div>

      <div class="echart-box" v-show="currentIndex === 1">
        <div class="echart-item" v-for="(data, key) in icyrRoadData" :key="key" :class="key">
          <div :id="'echart' + key" class="echart"></div>
        </div>
      </div>
    </div>
    <div class="point-box" v-show="currentIndex === 1">
      <div class="point-item" v-for="(data, key) in icyrRoadData" :key="key" @mouseover=mouseover(key)></div>
    </div>
    <div class="no-data" v-show="times.length === 0">无道路结冰数据~</div>
  </div>
</template>

<script>
import { apiData } from '@/api/index'
import echarts from '@/config/echarts'
import { getIcyRaod } from '@/config/echarts/option/icy-road.js'
export default {
  data() {
    return {
      currentIndex: 0,
      tabData: ['研判', '预报'],
      myEcharts: {},
      times: [],
      dataIndex: 0,
      pTime: '',
      ypcont: '',
      icyrRoadData: {}
    }
  },
  methods: {
    tabItemClick(index) {
      this.currentIndex = index
      if (index === 1) {
        this.$nextTick(() => this.initEcahrt())
      }
    },

    initEcahrt() {
      if (Object.keys(this.myEcharts).length === 0) {
        const lastIndex = this.dataIndex + 24
        for (const key in this.icyrRoadData) {
          const data = this.icyrRoadData[key]
          const dom = document.getElementById('echart' + key)
          const echart = echarts.init(dom)
          this.myEcharts[key] = echart
          const option = getIcyRaod()
          option.title.text = key
          option.xAxis.data = this.times
          option.series[0].data = data.rains.slice(this.dataIndex, lastIndex)
          option.series[1].data = data.temps.slice(this.dataIndex, lastIndex)
          option.series[2].data = data.dtmps.slice(this.dataIndex, lastIndex)

          echart.setOption(option)
        }
      } else {
        for (const key in this.myEcharts) {
          this.myEcharts[key].resize()
        }
      }
    },

    async queryNewestRoadicingData() {
      const { company } = this.$route.params
      const { unit } = JSON.parse(localStorage.getItem(company))
      const result = await apiData.queryNewestRoadicingData(unit.id)
      if (!result.data) {
        this.times = []
        return ''
      }
      let index = 0
      const pTime = new Date(result.data.ddatetime).getTime()
      this.pTime = this.$moment(pTime).format('YYYY-MM-DD HH:mm')
      let time = Date.now()
      if (pTime < time) {
        index = Math.ceil((time - pTime) / 3600000)
        time = index * 3600000 + pTime
      } else {
        time = pTime
      }
      const times = []
      for (let index = 0; index < 24; index++) {
        times.push(index * 3600000 + time)
      }
      this.times = times
      this.dataIndex = index
      this.icyrRoadData = JSON.parse(result.data.fore)
      this.ypcont = result.data.ypcont
    },
    mouseover(key) {
      const itemEl = document.querySelector('.' + key)
      const contEl = document.querySelector('.echart-box')
      contEl.scrollTo({
        top: itemEl.offsetTop,
        left: 0,
        behavior: 'smooth'
      })
    }

  },
  mounted() {
    this.queryNewestRoadicingData()
    window.addEventListener('resize', () => {
      for (const key in this.myEcharts) {
        this.myEcharts[key].resize()
      }
    })
  }
}
</script>

<style lang="less" scoped>
.icy-road {
  display: flex;
  flex-direction: column;
  height: calc(100% - 3vw);
  width: 100%;

  .hasData-wrap {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  .tab-box {
    display: flex;
    position: absolute;
    top: -2vw;
    left: 7.86vw;
    z-index: 10;
    transform: translateY(-50%);
    // padding: 10px 0 0 20px;

    .tab-item {
      margin-right: 0.78vw;
      color: #FFF;
      font-size: 0.73vw;
      font-weight: 600;
      cursor: pointer;

    }

    .tab-item.active {
      color: #ffb700;
    }

  }

  .cont-box {
    padding: 1.04vw;
    flex: 1;
    line-height: 1.82vw;
    color: #FFF;
    font-size: 0.73vw;
    font-weight: 600;
  }

  .echart-box {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
    position: relative;

    .echart-item {
      display: flex;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 0 1.04vw 0.56vw 1.04vw;
      flex-shrink: 0;

      .echart {
        flex: 1;
      }
    }

  }

  .echart-box::-webkit-scrollbar {
    width: 0vw;
  }

  .echart-box::-webkit-scrollbar-track {
    background: #E7E7E7;
    border-radius: 1.09vw;
  }

  .echart-box::-webkit-scrollbar-thumb {
    background: #D8D8D8;
    border-radius: 1.09vw;
    height: 1.56vw;
  }

  .echart-box::-webkit-scrollbar-track {
    background: #0C355F;
  }

  .echart-box::-webkit-scrollbar-thumb {
    background: #2F557A;
  }

  .no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: 0.84vw;
    font-weight: 600;
    color: #FFF;

  }

  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: -1.6vw;
    color: #FFF;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }

  .point-box {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 60%;
    transform: translateY(-50%);
    right: 0.6vw;

    .point-item {
      width: 0.32vw;
      height: 0.32vw;
      margin-bottom: .6vw;
      border: 1px solid #EEE;
      background: #FFF;
      border-radius: 100%;
    }

    .point-item:hover {
      background: #ffb700;
      cursor: pointer;
    }
  }
}
</style>
